"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var propWithinRange = function (min, max) { return function (props, propName, componentName) {
    componentName = componentName || 'ANONYMOUS';
    var value = props[propName];
    if (value === undefined || value === null) {
        return null;
    }
    if (typeof value !== 'number') {
        return new Error(propName + " in " + componentName + " is not a number, got " + typeof value);
    }
    if (value < min || value > max) {
        return new Error(propName + " in " + componentName + " is not between [" + min + ", " + max + "]. Got " + value);
    }
    return null;
}; };
exports.featureShapePropType = prop_types_1.default.shape({
    id: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    source: prop_types_1.default.string.isRequired,
    sourceLayer: prop_types_1.default.string
});
exports.LngLatLikePropType = prop_types_1.default.oneOfType([
    prop_types_1.default.arrayOf(prop_types_1.default.number),
    prop_types_1.default.shape({
        lon: prop_types_1.default.number,
        lat: prop_types_1.default.number
    })
]);
exports.PitchPropType = propWithinRange(0, 60);
exports.BearingPropType = propWithinRange(0, 360);
exports.LngLatBoundsLikePropType = prop_types_1.default.arrayOf(exports.LngLatLikePropType);
exports.MapboxDebugPropType = prop_types_1.default.oneOfType([
    prop_types_1.default.bool,
    prop_types_1.default.shape({
        showCollisionBoxes: prop_types_1.default.bool,
        showPadding: prop_types_1.default.bool,
        showTileBoundaries: prop_types_1.default.bool,
        repaint: prop_types_1.default.bool
    })
]);
exports.MapDebugPropType = prop_types_1.default.oneOfType([
    prop_types_1.default.bool,
    prop_types_1.default.shape({
        mapbox: exports.MapboxDebugPropType
    })
]);
